import React, { useState, useEffect } from 'react';

// apiBase/token: yonetim panelindeki AI Center bu bilesenleri DEGISTIRMEDEN
// yeniden kullanabilsin diye opsiyonel - verilmezse tenant'taki mevcut
// davranis (kendi crm_token'i + /api/callops) AYNEN korunur.
const LeadsTab = ({ apiBase = '/api/callops', token } = {}) => {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [viewMode, setViewMode] = useState('kanban');
  const [selectedLead, setSelectedLead] = useState(null);
  const [draggedLead, setDraggedLead] = useState(null);
  const [dragOverCol, setDragOverCol] = useState(null);
  const [calling, setCalling] = useState(false);
  const [search, setSearch] = useState('');
  const authToken = token || localStorage.getItem('crm_token');

  useEffect(() => { fetchLeads(); }, []);

  const fetchLeads = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${apiBase}/leads`, {
        headers: { Authorization: `Bearer ${authToken}` }
      });
      const data = await res.json();
      setLeads(data.leads || []);
    } catch (err) { console.error(err); }
    setLoading(false);
  };

  const formatDate = (date) => date ? new Date(date).toLocaleString('tr-TR') : '-';
  const flags = { TR:'🇹🇷', US:'🇺🇸', DE:'🇩🇪', GB:'🇬🇧', SA:'🇸🇦', FR:'🇫🇷', IT:'🇮🇹' };

  const columns = [
    { id: 'priority',   title: 'Öncelikli',  color: '#F87171', bg: 'rgba(248,113,113,0.08)',  icon: '🔴' },
    { id: 'interested', title: 'İlgili',      color: '#60A5FA', bg: 'rgba(96,165,250,0.08)',   icon: '🔵' },
    { id: 'follow_up',  title: 'Takipte',     color: '#FBBF24', bg: 'rgba(251,191,36,0.08)',   icon: '🟡' },
    { id: 'converted',  title: 'Dönüşüm',    color: '#34D399', bg: 'rgba(52,211,153,0.08)',   icon: '🟢' },
    { id: 'lost',       title: 'Kayıp',       color: '#6B7280', bg: 'rgba(107,114,128,0.08)', icon: '⚫' }
  ];

  const getLeadsByColumn = (colId) =>
    leads.filter(l => l.priority === colId && (!search || `${l.name} ${l.phone} ${l.sector}`.toLowerCase().includes(search.toLowerCase())));

  const handleDragStart = (e, lead) => { setDraggedLead(lead); e.dataTransfer.effectAllowed = 'move'; };
  const handleDragOver = (e, colId) => { e.preventDefault(); e.dataTransfer.dropEffect = 'move'; setDragOverCol(colId); };
  const handleDragLeave = () => setDragOverCol(null);

  const handleDrop = async (e, columnId) => {
    e.preventDefault(); setDragOverCol(null);
    if (!draggedLead || draggedLead.priority === columnId) return;
    setLeads(prev => prev.map(l => l.id === draggedLead.id ? { ...l, priority: columnId } : l));
    try {
      await fetch(`${apiBase}/leads/${draggedLead.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${authToken}` },
        body: JSON.stringify({ priority: columnId })
      });
    } catch (err) { console.error(err); fetchLeads(); }
    setDraggedLead(null);
  };

  const updateLeadStatus = async (id, status) => {
    try {
      await fetch(`${apiBase}/leads/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${authToken}` },
        body: JSON.stringify({ status })
      });
      fetchLeads(); setSelectedLead(null);
    } catch (err) { console.error(err); }
  };

  const callLead = async (id) => {
    setCalling(true);
    try {
      const res = await fetch(`${apiBase}/leads/${id}/call`, {
        method: 'POST', headers: { Authorization: `Bearer ${authToken}` }
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Arama başlatılamadı');
    } catch (err) { console.error(err.message); }
    setCalling(false);
  };

  const deleteLead = async (id) => {
    if (!window.confirm('Lead silinsin mi?')) return;
    try {
      await fetch(`${apiBase}/leads/${id}`, {
        method: 'DELETE', headers: { Authorization: `Bearer ${authToken}` }
      });
      fetchLeads(); setSelectedLead(null);
    } catch (err) { console.error(err); }
  };

  const LeadCard = ({ lead, col }) => (
    <div
      className={`lead-card ${draggedLead?.id === lead.id ? 'dragging' : ''}`}
      draggable onDragStart={e => handleDragStart(e, lead)}
      onClick={() => setSelectedLead(lead)}
    >
      <div className="lc-header">
        <span style={{ fontSize:16 }}>{flags[lead.country_code] || '🌍'}</span>
        <span className="lc-phone">{lead.phone}</span>
        <span className="lc-calls">📞 {lead.call_count}</span>
      </div>
      <div className="lc-name">{lead.name}</div>
      {lead.sector && <div className="lc-sector">{lead.sector}</div>}
      {lead.ai_summary && (
        <div className="lc-summary">{lead.ai_summary.substring(0, 65)}...</div>
      )}
      {lead.suggested_action && (
        <div className="lc-action">💡 {lead.suggested_action.substring(0, 55)}...</div>
      )}
      <div className="lc-footer">
        <span>{formatDate(lead.last_contact_at)}</span>
        {lead.assigned_staff_name && <span>👤 {lead.assigned_staff_name}</span>}
      </div>
    </div>
  );

  const totalLeads = leads.filter(l => !search || `${l.name} ${l.phone} ${l.sector}`.toLowerCase().includes(search.toLowerCase())).length;

  return (
    <div className="leads-tab">
      {/* Header */}
      <div className="leads-header">
        <div>
          <h2>🎯 Leadler</h2>
          <p style={{ margin:0, color:'#6B7280', fontSize:13 }}>{totalLeads} lead</p>
        </div>
        <div className="leads-toolbar">
          <div className="leads-search-wrap">
            <span className="leads-search-icon">🔍</span>
            <input className="leads-search" placeholder="Ara..." value={search} onChange={e => setSearch(e.target.value)} />
          </div>
          <div className="view-toggle">
            <button className={viewMode === 'kanban' ? 'active' : ''} onClick={() => setViewMode('kanban')}>⬛ Kanban</button>
            <button className={viewMode === 'table' ? 'active' : ''} onClick={() => setViewMode('table')}>📋 Tablo</button>
          </div>
          <button className="leads-refresh-btn" onClick={fetchLeads}>🔄</button>
        </div>
      </div>

      {/* Column Summary */}
      <div className="cols-summary">
        {columns.map(col => (
          <div key={col.id} className="col-sum" style={{ borderColor: col.color + '40' }}>
            <span style={{ fontSize:18 }}>{col.icon}</span>
            <div>
              <div className="col-sum-val" style={{ color: col.color }}>{getLeadsByColumn(col.id).length}</div>
              <div className="col-sum-lbl">{col.title}</div>
            </div>
          </div>
        ))}
      </div>

      {loading ? (
        <div className="leads-loading"><div className="leads-spinner" /><span>Yükleniyor...</span></div>
      ) : viewMode === 'kanban' ? (
        <div className="kanban-board">
          {columns.map(col => {
            const colLeads = getLeadsByColumn(col.id);
            const isOver = dragOverCol === col.id;
            return (
              <div
                key={col.id}
                className={`kanban-col ${isOver ? 'drag-over' : ''}`}
                style={{ '--col-color': col.color, '--col-bg': col.bg }}
                onDragOver={e => handleDragOver(e, col.id)}
                onDragLeave={handleDragLeave}
                onDrop={e => handleDrop(e, col.id)}
              >
                <div className="kanban-col-header">
                  <div className="kanban-col-title">
                    <span>{col.icon}</span>
                    <span>{col.title}</span>
                  </div>
                  <span className="kanban-col-count" style={{ color: col.color, background: col.bg }}>{colLeads.length}</span>
                </div>
                <div className="kanban-col-body">
                  {colLeads.map(lead => <LeadCard key={lead.id} lead={lead} col={col} />)}
                  {colLeads.length === 0 && (
                    <div className="col-empty">Buraya sürükleyin</div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="leads-table-wrap">
          <table className="leads-table">
            <thead>
              <tr>
                <th></th><th>Müşteri</th><th>Telefon</th><th>Sektör</th><th>Arama</th><th>Durum</th><th>Son İletişim</th>
              </tr>
            </thead>
            <tbody>
              {leads
                .filter(l => !search || `${l.name} ${l.phone} ${l.sector}`.toLowerCase().includes(search.toLowerCase()))
                .map(lead => {
                  const col = columns.find(c => c.id === lead.priority);
                  return (
                    <tr key={lead.id} className="leads-row" onClick={() => setSelectedLead(lead)}>
                      <td style={{ textAlign:'center', fontSize:18 }}>{flags[lead.country_code] || '🌍'}</td>
                      <td><div className="lt-name">{lead.name}</div></td>
                      <td className="lt-phone">{lead.phone}</td>
                      <td className="lt-muted">{lead.sector || '-'}</td>
                      <td className="lt-center">{lead.call_count}</td>
                      <td>
                        <span style={{ background: col?.bg, color: col?.color, border: `1px solid ${col?.color}33`, padding:'3px 10px', borderRadius:20, fontSize:11, fontWeight:700 }}>
                          {col?.icon} {col?.title || lead.priority}
                        </span>
                      </td>
                      <td className="lt-muted">{formatDate(lead.last_contact_at)}</td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </div>
      )}

      {/* Detail Modal */}
      {selectedLead && (
        <div className="modal-overlay" onClick={() => setSelectedLead(null)}>
          <div className="lead-modal" onClick={e => e.stopPropagation()}>
            <div className="lead-modal-hdr">
              <div>
                <h3 style={{ margin:'0 0 4px', color:'#F9FAFB' }}>{selectedLead.name}</h3>
                <div style={{ fontSize:13, color:'#6B7280' }}>{flags[selectedLead.country_code] || '🌍'} {selectedLead.phone}</div>
              </div>
              <button className="modal-x" onClick={() => setSelectedLead(null)}>×</button>
            </div>
            <div className="lead-modal-bdy">
              <div className="lead-detail-grid">
                <div className="ld-cell"><label>Sektör</label><div>{selectedLead.sector || '-'}</div></div>
                <div className="ld-cell"><label>Arama Sayısı</label><div>{selectedLead.call_count}</div></div>
                <div className="ld-cell"><label>Son İletişim</label><div>{formatDate(selectedLead.last_contact_at)}</div></div>
                <div className="ld-cell"><label>Durum</label>
                  <select className="ld-select" value={selectedLead.priority} onChange={e => updateLeadStatus(selectedLead.id, e.target.value)}>
                    {columns.map(c => <option key={c.id} value={c.id}>{c.icon} {c.title}</option>)}
                  </select>
                </div>
              </div>

              {selectedLead.ai_summary && (
                <div className="ld-info-box blue">
                  <label>🤖 AI Özeti</label>
                  <div>{selectedLead.ai_summary}</div>
                </div>
              )}

              {selectedLead.suggested_action && (
                <div className="ld-info-box green">
                  <label>💡 Önerilen Aksiyon</label>
                  <div>{selectedLead.suggested_action}</div>
                </div>
              )}

              {selectedLead.notes && (
                <div className="ld-info-box gray">
                  <label>📝 Notlar</label>
                  <div>{selectedLead.notes}</div>
                </div>
              )}
            </div>
            <div className="lead-modal-ftr">
              <button className="ld-btn-danger" onClick={() => deleteLead(selectedLead.id)}>🗑 Sil</button>
              <button className="ld-btn-primary" disabled={calling} onClick={() => callLead(selectedLead.id)}>
                {calling ? '⏳ Aranıyor...' : '📞 Ara'}
              </button>
              <button className="ld-btn-secondary" onClick={() => setSelectedLead(null)}>Kapat</button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        .leads-tab { display:flex; flex-direction:column; gap:20px; }

        .leads-header { display:flex; justify-content:space-between; align-items:flex-start; }
        .leads-header h2 { margin:0 0 2px; font-size:22px; font-weight:700; color:#F9FAFB; }

        .leads-toolbar { display:flex; gap:10px; align-items:center; }
        .leads-search-wrap { position:relative; }
        .leads-search-icon { position:absolute; left:10px; top:50%; transform:translateY(-50%); font-size:12px; }
        .leads-search { padding:9px 12px 9px 30px; background:rgba(255,255,255,0.05); border:1px solid rgba(255,255,255,0.08); border-radius:10px; color:#E5E7EB; font-size:13px; outline:none; width:160px; }
        .leads-search:focus { border-color:rgba(96,165,250,0.4); }

        .view-toggle { display:flex; background:rgba(255,255,255,0.04); border:1px solid rgba(255,255,255,0.07); padding:3px; border-radius:10px; }
        .view-toggle button { padding:7px 14px; border:none; background:transparent; color:#6B7280; font-size:12px; font-weight:500; cursor:pointer; border-radius:8px; transition:all 0.2s; }
        .view-toggle button.active { background:rgba(96,165,250,0.15); color:#60A5FA; }

        .leads-refresh-btn { width:38px; height:38px; background:rgba(255,255,255,0.06); border:1px solid rgba(255,255,255,0.08); border-radius:10px; font-size:16px; cursor:pointer; transition:all 0.2s; }
        .leads-refresh-btn:hover { background:rgba(255,255,255,0.1); }

        .cols-summary { display:grid; grid-template-columns:repeat(5,1fr); gap:10px; }
        .col-sum { background:rgba(17,17,24,0.7); border:1px solid; border-radius:12px; padding:12px 14px; display:flex; align-items:center; gap:10px; backdrop-filter:blur(12px); }
        .col-sum-val { font-size:20px; font-weight:800; line-height:1; }
        .col-sum-lbl { font-size:11px; color:#6B7280; text-transform:uppercase; letter-spacing:0.04em; margin-top:2px; }

        .leads-loading { display:flex; align-items:center; justify-content:center; flex-direction:column; gap:14px; padding:80px; color:#6B7280; font-size:14px; }
        .leads-spinner { width:36px; height:36px; border:3px solid rgba(255,255,255,0.08); border-top-color:#60A5FA; border-radius:50%; animation:spin 0.8s linear infinite; }
        @keyframes spin { to { transform:rotate(360deg); } }

        /* Kanban */
        .kanban-board { display:flex; gap:14px; overflow-x:auto; padding-bottom:8px; }
        .kanban-col { min-width:240px; flex:1; background:rgba(17,17,24,0.6); border:2px solid rgba(255,255,255,0.06); border-radius:16px; display:flex; flex-direction:column; transition:border-color 0.2s, background 0.2s; backdrop-filter:blur(16px); }
        .kanban-col.drag-over { border-color:var(--col-color); background:var(--col-bg); }
        .kanban-col-header { display:flex; justify-content:space-between; align-items:center; padding:14px 14px 10px; border-bottom:1px solid rgba(255,255,255,0.06); }
        .kanban-col-title { display:flex; align-items:center; gap:8px; font-size:13px; font-weight:700; color:#E5E7EB; }
        .kanban-col-count { padding:3px 10px; border-radius:20px; font-size:12px; font-weight:700; }
        .kanban-col-body { padding:10px; flex:1; display:flex; flex-direction:column; gap:8px; min-height:120px; }
        .col-empty { text-align:center; padding:20px; color:#374151; font-size:12px; border:2px dashed rgba(255,255,255,0.08); border-radius:10px; }

        .lead-card { background:rgba(26,26,38,0.9); border:1px solid rgba(255,255,255,0.07); border-radius:12px; padding:13px; cursor:grab; transition:all 0.2s; }
        .lead-card:hover { border-color:rgba(96,165,250,0.25); transform:translateY(-1px); box-shadow:0 6px 20px rgba(0,0,0,0.3); }
        .lead-card.dragging { opacity:0.5; cursor:grabbing; }
        .lc-header { display:flex; align-items:center; gap:6px; margin-bottom:6px; }
        .lc-phone { font-size:11px; color:#6B7280; flex:1; }
        .lc-calls { font-size:11px; color:#4B5563; }
        .lc-name { font-size:13px; font-weight:700; color:#E5E7EB; margin-bottom:3px; }
        .lc-sector { font-size:11px; color:#6B7280; margin-bottom:6px; }
        .lc-summary { font-size:11px; color:#60A5FA; background:rgba(96,165,250,0.08); border:1px solid rgba(96,165,250,0.15); padding:7px 9px; border-radius:8px; margin-bottom:6px; line-height:1.4; }
        .lc-action { font-size:11px; color:#34D399; background:rgba(52,211,153,0.08); border:1px solid rgba(52,211,153,0.15); padding:7px 9px; border-radius:8px; margin-bottom:6px; line-height:1.4; }
        .lc-footer { display:flex; justify-content:space-between; font-size:10px; color:#4B5563; }

        /* Table */
        .leads-table-wrap { background:rgba(17,17,24,0.7); border:1px solid rgba(255,255,255,0.07); border-radius:16px; overflow:hidden; backdrop-filter:blur(16px); }
        .leads-table { width:100%; border-collapse:collapse; }
        .leads-table thead th { padding:12px 16px; text-align:left; font-size:11px; text-transform:uppercase; letter-spacing:0.06em; color:#6B7280; font-weight:700; background:rgba(255,255,255,0.03); border-bottom:1px solid rgba(255,255,255,0.06); }
        .leads-row { cursor:pointer; transition:background 0.15s; }
        .leads-row:hover { background:rgba(255,255,255,0.04); }
        .leads-row td { padding:13px 16px; border-bottom:1px solid rgba(255,255,255,0.04); vertical-align:middle; }
        .leads-row:last-child td { border-bottom:none; }
        .lt-name { font-size:14px; font-weight:600; color:#E5E7EB; }
        .lt-phone { font-size:13px; color:#6B7280; font-family:monospace; }
        .lt-muted { font-size:13px; color:#6B7280; }
        .lt-center { text-align:center; font-weight:600; color:#E5E7EB; }

        /* Modal */
        .modal-overlay { position:fixed; inset:0; background:rgba(0,0,0,0.7); backdrop-filter:blur(8px); display:flex; align-items:center; justify-content:center; z-index:1000; padding:20px; }
        .lead-modal { background:#0f0f16; border:1px solid rgba(255,255,255,0.1); border-radius:20px; width:100%; max-width:580px; max-height:85vh; overflow:hidden; display:flex; flex-direction:column; box-shadow:0 24px 60px rgba(0,0,0,0.6); }
        .lead-modal-hdr { display:flex; justify-content:space-between; align-items:flex-start; padding:20px 24px; border-bottom:1px solid rgba(255,255,255,0.07); }
        .modal-x { background:none; border:none; font-size:28px; color:#6B7280; cursor:pointer; line-height:1; transition:color 0.15s; }
        .modal-x:hover { color:#F87171; }
        .lead-modal-bdy { padding:24px; overflow-y:auto; display:flex; flex-direction:column; gap:14px; }
        .lead-modal-ftr { display:flex; gap:10px; justify-content:flex-end; padding:16px 24px; border-top:1px solid rgba(255,255,255,0.07); }

        .lead-detail-grid { display:grid; grid-template-columns:repeat(2,1fr); gap:10px; }
        .ld-cell { background:rgba(255,255,255,0.03); border:1px solid rgba(255,255,255,0.06); border-radius:10px; padding:12px 14px; }
        .ld-cell label { font-size:11px; text-transform:uppercase; letter-spacing:0.05em; color:#6B7280; display:block; margin-bottom:5px; }
        .ld-cell > div { font-size:14px; font-weight:600; color:#E5E7EB; }
        .ld-select { background:rgba(255,255,255,0.05); border:1px solid rgba(255,255,255,0.1); border-radius:8px; color:#E5E7EB; font-size:13px; padding:5px 10px; outline:none; width:100%; }
        .ld-select option { background:#13131a; }

        .ld-info-box { border-radius:12px; padding:14px; }
        .ld-info-box.blue { background:rgba(96,165,250,0.07); border:1px solid rgba(96,165,250,0.15); }
        .ld-info-box.green { background:rgba(52,211,153,0.07); border:1px solid rgba(52,211,153,0.15); }
        .ld-info-box.gray { background:rgba(107,114,128,0.07); border:1px solid rgba(107,114,128,0.15); }
        .ld-info-box label { font-size:12px; font-weight:700; display:block; margin-bottom:8px; }
        .ld-info-box.blue label { color:#60A5FA; }
        .ld-info-box.green label { color:#34D399; }
        .ld-info-box.gray label { color:#9CA3AF; }
        .ld-info-box > div { font-size:14px; color:#D1D5DB; line-height:1.6; }

        .ld-btn-danger { padding:10px 18px; background:rgba(248,113,113,0.12); border:1px solid rgba(248,113,113,0.25); border-radius:10px; color:#F87171; font-size:13px; font-weight:600; cursor:pointer; }
        .ld-btn-primary { padding:10px 20px; background:linear-gradient(135deg,#1d4ed8,#60A5FA); border:none; border-radius:10px; color:#fff; font-size:13px; font-weight:700; cursor:pointer; }
        .ld-btn-primary:disabled { opacity:0.6; cursor:not-allowed; }
        .ld-btn-secondary { padding:10px 18px; background:rgba(255,255,255,0.06); border:1px solid rgba(255,255,255,0.08); border-radius:10px; color:#9CA3AF; font-size:13px; cursor:pointer; }
      `}</style>
    </div>
  );
};

export default LeadsTab;
